export function contactsSlider() {
    const $window = this.$window;
    $window.on("load", () => {
        const $slider = $(".contacts-slider");

        $slider.each((index, slider) => {
            const $sliderItem = $(slider);
            const $contactSection = $sliderItem.closest(".contacts-section");
            let ww = $window.outerWidth();
            let slidesCount = $sliderItem.find(".item").length;
            let isCenterMode = true;

            if ((ww < 768 && slidesCount <= 2) ||
                (ww >= 768 && ww < 1200 && slidesCount <= 4) ||
                (ww >= 1200 && slidesCount <= 4)
            ) {
                isCenterMode = false;
                $contactSection.removeClass("wide-style");
            } else {
                isCenterMode = true;
                $contactSection.addClass("wide-style");
            }

            $sliderItem.slick({
                mobileFirst: true,

                infinite: false,
                autoplay: false,
                arrows: isCenterMode,
                pauseOnHover: false,

                centerMode: false,
                centerPadding: isCenterMode ? "10px" : "0px",
                slidesToScroll: 1,
                initialSlide: 0,
                variableWidth: true,
                responsive: [{
                    breakpoint: 10000,
                    settings: {
                        slidesToShow:7,
                        // slidesToShow: isCenterMode?4.97:5, // 4.97 value generates error during the slick initialization
                        // slidesToShow: 5, // 3.97 value is correct but doesn't match the design
                        centerPadding: "0px",
                        // initialSlide: isCenterMode?2:0,
                    }
                }, {
                    breakpoint: 2500,
                    settings: {
                        slidesToShow: 6, // 4.97 value generates error during the slick initialization
                        // slidesToShow: isCenterMode?3.97:5, // 3.97 value is correct but doesn't match the design
                        centerPadding: "0px",
                        // initialSlide: isCenterMode?2:0,
                    }
                }, {
                    breakpoint: 2000,
                    settings: {
                        slidesToShow: 5, // 4.97 value generates error during the slick initialization
                        // slidesToShow: isCenterMode?3.97:5, // 3.97 value is correct but doesn't match the design
                        centerPadding: "0px",
                        // initialSlide: isCenterMode?2:0,
                    }
                }, {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 4, // 4.97 value generates error during the slick initialization
                        // slidesToShow: isCenterMode?3.97:5, // 3.97 value is correct but doesn't match the design
                        centerPadding: "0px",
                        // initialSlide: isCenterMode?2:0,
                    }
                }, {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 3,
                        // initialSlide: isCenterMode?1:0,
                        // centerMode: isCenterMode
                    }
                }, {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        // initialSlide: isCenterMode?1:0,
                        // centerMode: isCenterMode
                    }
                }, {
                    breakpoint: 849,
                    settings: {
                        slidesToShow: 3,
                        // initialSlide: isCenterMode?1:0,
                        // centerMode: isCenterMode
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        // initialSlide: isCenterMode?1:0,
                        // centerMode: isCenterMode
                    }
                }]
            });

        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contacts-slider.js